import React, { useState, useEffect, useMemo } from 'react'

import {
  COLORS,
  COLOR_MODE_KEY,
  INITIAL_COLOR_MODE_CSS_PROP
} from '../constants'

// const defaultState = {
//   dark: false,
//   toggleDark: () => {},
// }

export const ThemeContext = React.createContext()

const ThemeProvider = ({ children }) => {
  const [colorMode, rawSetColorMode] = React.useState(undefined);
  const [settings, setSettings] = useState([])

  useEffect(() => {
    const root = window.document.documentElement;

    // Because colors matter so much for the initial page view, we're
    // doing a lot of the work in gatsby-ssr. That way it can happen before
    // the React component tree mounts.

    const initialColorValue = root.style.getPropertyValue(
      INITIAL_COLOR_MODE_CSS_PROP
    )

    rawSetColorMode(initialColorValue)
  }, [])

  const contextValue = useMemo(() => {
    function setColorMode(newValue) {
      const root = window.document.documentElement
      const raw = localStorage.getItem('dcfz-settings')

      let current = null

      try {
        const parsed = raw ? JSON.parse(raw) : null
        current = Array.isArray(parsed) && parsed[0] ? parsed[0] : null
      } catch (error) {
        current = null
      }

      const next = {
        consent: current?.consent || 'yes',
        lang: current?.lang || (document.documentElement.lang?.startsWith('de') ? 'de' : 'en'),
        colorMode: newValue,
        advert: current?.advert || '',
        createdAt: current?.createdAt || Date.now(),
      }

      localStorage.setItem('dcfz-settings', JSON.stringify([next]))

      Object.entries(COLORS).forEach(([name, colorByTheme]) => {
        root.style.setProperty(`--color-${name}`, colorByTheme[newValue])
      })

      rawSetColorMode(newValue)
    }

    return {
      colorMode,
      setColorMode,
    }
  }, [colorMode, rawSetColorMode]);

  return (
    <ThemeContext.Provider value={contextValue}>
      {children}
    </ThemeContext.Provider>
  )
}

// export default ThemeContext

export { ThemeProvider }
